<template>
  <div v-loading.fullscreen.lock="isPageLoading" class="management-control">
    <!-- 因為會有需要跳轉到v4判斷，所以在此需多判斷一個v-if -->
    <div v-if="isShowingManagementButton" class="management-control_contain">
      <div class="title">
        管理費
      </div>
      <div class="management-control_button">
        <div @click="$router.push({ name: management, params: { type: 'management' } })">
          <div class="content">
            <i
              class="icon-management-fee-member"
              aria-hidden="true"
            />
            管理費專戶
          </div>
        </div>
        <div @click="$router.push({ name: otherManagement, params: { type: 'other-management' } })">
          <div class="content">
            <i
              class="icon-other-fee-member"
              aria-hidden="true"
            />
            其他費用專戶
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { housekeeperAPI } from '@/api/HousekeeperAPI'

export default {
  data () {
    return {
      isPageLoading: true,
      isShowingManagementButton: false,
      management: null,
      otherManagement: null
    }
  },
  mounted () {
    this.getManagementFeeSetting()
  },
  methods: {
    /**
     * 取得社區管理費設定
     * 判斷一般管理費和其他管理費的版本，並設定對應的路由
     */
    async getManagementFeeSetting () {
      const BillServiceType = Object.freeze({
        Management: 1, // 一般管理費
        OtherManagement: 2 // 其他管理費
      })

      this.isPageLoading = true

      try {
        const response = await housekeeperAPI.getCommunityBillServiceSettings()
        const data = response.data.Data
        const usingList = data.CommunityBillServiceSettings.filter(el => el.IsInUse)

        // 找出一般管理費和其他管理費設定
        const managementFee = usingList.find(el => el.BillServiceType === BillServiceType.Management)
        const otherFee = usingList.find(el => el.BillServiceType === BillServiceType.OtherManagement)

        // 檢查是否有可用的管理費
        if (usingList.length === 0) {
          throw new Error('沒有可用的管理費')
        }

        // 如果只有一種管理費類型，直接跳轉到對應頁面
        if (usingList.length === 1) {
          const singleFee = usingList[0]
          const routeName = singleFee.BillServiceVersion === 3 ? 'FeePeriodList' : 'KGIFeePeriodList'
          this.$router.push({ name: routeName }) // 不帶 type 參數，便可使用「上一頁」返回首頁
          return
        }

        // 設定兩種管理費類型的路由名稱
        this.management = managementFee?.BillServiceVersion === 3 ? 'FeePeriodList' : 'KGIFeePeriodList'
        this.otherManagement = otherFee?.BillServiceVersion === 3 ? 'FeePeriodList' : 'KGIFeePeriodList'
        this.isShowingManagementButton = true
      } catch (error) {
        console.error('取得社區設定失敗:', error)
        this.handleGetManagementFeeSettingError(error)
      } finally {
        this.isPageLoading = false
      }
    },
    /**
     * 處理取得社區設定時的錯誤
     * @param {Error} error - 錯誤物件
     */
    handleGetManagementFeeSettingError (error) {
      let msg = ''
      if (!error.response) {
        msg = this.$t('Server.TryAgainLater')
      } else if (error.response?.data?.ErrorMessage?.Code === 400000) {
        msg = this.$t('Auth.ServiceNotAvailable')
      } else if (error.response?.status === 400) {
        msg = this.$t('Auth.ServiceNotAvailable')
      }
      if (!msg) return
      this.$alert(msg, this.$t('General.AlertTitle'), {
        confirmButtonText: this.$t('General.Confirm'),
        type: 'warning',
        showClose: false,
        roundButton: true,
        closeOnClickModal: false
      }).then(() => {
        // 回首頁
        this.$toMainPage()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.management-control{
  @include mainLayer();
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  .management-control_contain{
    min-width: 1140px;
    max-width: 90%;
    height: 421px;
    background-color: #fff;
    .title{
      text-align: left;
      font-size: 25px;
      font-weight: bold;
      width: 100%;
      padding: 16px 24px;
      border: 1px solid $bgDarkBg;
    }
    .management-control_button {
      display: flex;
      justify-content: center;
      align-items: center;
      height: calc(100% - 60px);
      gap:30px;
      > div {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 20px;
          cursor: pointer;
          width: 210px;
          height: 210px;
          background-color: #fff;
          box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
          border-radius: 15px;
      }
      .content{
        display: flex;
        flex-direction: column;
        & > i {
          font-size: 84px;
          margin-bottom: 16px;
        }
        font-size: 29px;
        font-weight: bold;
      }
    }
  }
}
</style>
